import { ClockIcon, LocationIcon, MailIcon } from "../../../constants/svgs";
import { HStack, Link, Text, VStack } from "@chakra-ui/react";

import React from "react";
import SocialIcons from "../../socials/social-icons";
import useLanguage from "../../../hooks/useLanguage";

type ContactLinksProps = {
  padding: string;
  hasRadnoVreme: boolean;
};

const ContactLinks = ({ padding, hasRadnoVreme }: ContactLinksProps) => {
  const isEnglish = useLanguage();
  return (
    <VStack
      alignItems="flex-start"
      gap="12px"
      bg="gray.50"
      borderRadius="3xl"
      p={padding}
      marginInlineStart="0px!important"
      minW={{ base: "100%", md: "307px", sm: "376px" }}>
      <HStack alignItems="flex-start" gap="0.75rem">
        <div
          dangerouslySetInnerHTML={{
            __html: MailIcon("#BC2A2A", "20px", "20px"),
          }}
        />
        <VStack alignItems="flex-start">
          <Text fontWeight="600" color="rawSienna.500">
            {isEnglish ? "Contact" : "Контакт"}
          </Text>
          <Link
            href="mailto:info@svetionikznanja.rs"
            mt="0px !important"
            fontSize="14px"
            className="grid-numbers"
            textDecoration="underline"
            color="#4A5568">
            info@svetionikznanja.rs
          </Link>
          <Link
            href="mailto:info@afirmacijakulture.org"
            mt="0px !important"
            fontSize="14px"
            className="grid-numbers"
            textDecoration="underline"
            color="#4A5568">
            info@afirmacijakulture.org
          </Link>
        </VStack>
      </HStack>

      <HStack alignItems="flex-start" gap="0.75rem">
        <div
          dangerouslySetInnerHTML={{
            __html: LocationIcon("#BC2A2A", "20px", "20px"),
          }}
        />
        <VStack alignItems="flex-start">
          <Text fontWeight="600" color="rawSienna.500">
            {isEnglish ? "Address" : "Адреса"}
          </Text>
          <Text
            mt="0px !important"
            fontSize="14px"
            className="grid-numbers"
            color="#4A5568">
            {isEnglish
              ? "Brsjačka 28, 11000 Belgrade"
              : "Брсјачка 28, 11000 Београд"}
          </Text>
        </VStack>
      </HStack>

      {hasRadnoVreme && (
        <HStack alignItems="flex-start" gap="0.75rem">
          <div
            dangerouslySetInnerHTML={{
              __html: ClockIcon("#BC2A2A", "20px", "20px"),
            }}
          />
          <VStack alignItems="flex-start">
            <Text fontWeight="600" color="rawSienna.500">
              {isEnglish ? "Working hours:" : "Радно време:"}
            </Text>
            <Text
              mt="0px !important"
              fontSize="14px"
              className="grid-numbers"
              color="#4A5568">
              {isEnglish
                ? "Mon. - Sun.: 09:00 - 17:00"
                : "Пон. – Нед.: 09:00 – 17:00"}
            </Text>
          </VStack>
        </HStack>
      )}

      <SocialIcons
        paddingTop="12px"
        bgColor="rawSienna.50"
        hoverColor="rawSienna.200"
        iconColor="#BC2A2A"
        size="16px"
        bgSize="32px"
      />
    </VStack>
  );
};

export default ContactLinks;
